import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

const Layout = React.lazy(() => import("../layouts/layout"))
const ErrorPage = React.lazy(() => import("../pages/Error"))


// Load Page
const Home = React.lazy(() => import('../pages/Home'))
const Register = React.lazy(() => import('../pages/Auth/register'))
const Login = React.lazy(() => import('../pages/Auth/login'))
const ForgotPassword = React.lazy(() => import('../pages/Auth/forgotPassword'))
const Category = React.lazy(() => import('../pages/Category'))
const ProductDetails = React.lazy(() => import('../pages/Product'))
const Search = React.lazy(() => import('../pages/Search'))
const Cart = React.lazy(() => import('../pages/Cart'))
const Checkout = React.lazy(() => import('../pages/Checkout'))
const Profile = React.lazy(() => import('../pages/Profile'))
const Company = React.lazy(() => import('../pages/Profile/company'))
const Wishlist = React.lazy(() => import('../pages/Profile/wishlist'))
const History = React.lazy(() => import('../pages/Profile/history'))
const About = React.lazy(() => import('../pages/Contents/about'))
const Business = React.lazy(() => import('../pages/Contents/business'))
const Career = React.lazy(() => import('../pages/Contents/career'))
const Service = React.lazy(() => import('../pages/Service'))
const News = React.lazy(() => import('../pages/News'))
const NewsDetail = React.lazy(() => import('../pages/News/detail'))
const Location = React.lazy(() => import('../pages/Location'))
const SupportCenter = React.lazy(() => import('../pages/SupportCenter'))
const Quote = React.lazy(() => import('../pages/Quote'))
const Feedback = React.lazy(() => import('../pages/Feedback'))
const Contact = React.lazy(() => import('../pages/Contact'))
const KnowledgeHub = React.lazy(() => import('../pages/KnowledgeHub'))

const Privacy = React.lazy(() => import('../pages/Contents/privacy'))
const Cookie = React.lazy(() => import('../pages/Contents/cookie'))

const Brands = React.lazy(() => import('../pages/Brand'))
const BrandDetails = React.lazy(() => import('../pages/Brand/detail'))

const Router = createBrowserRouter([
	{
		path: '/',
		element: <Layout />,
		errorElement: <ErrorPage />,
		children: [
			{ index: true, element: <Home /> },
			// {
			// 	path: '/register',
			// 	element: <Register />,
			// },
			// {
			// 	path: '/login',
			// 	element: <Login />,
			// },
			// {
			// 	path: '/forgot-password',
			// 	element: <ForgotPassword />,
			// },
			{
				path: '/categories/:cat/:childCat?/:SuperChildCat?',
				element: <Category />,
			},
			{
				path: '/products/:sku',
				element: <ProductDetails />,
			},
			{
				path: '/brands',
				children: [
					{ index: true, element: <Brands /> },
					{
						path: '/brands/:slug',
						element: <BrandDetails />,
					}
				]
			},
			{
				path: '/search',
				element: <Search />,
			},
			{
				path: '/cart',
				element: <Cart />,
			},
			{
				path: '/checkout',
				element: <Checkout />,
			},
			// {
			// 	path: '/profile',
			// 	element: <Profile />,
			// },
			// {
			// 	path: '/company',
			// 	element: <Company />,
			// },
			// {
			// 	path: '/wishlist',
			// 	element: <Wishlist />,
			// },
			// {
			// 	path: '/history',
			// 	element: <History />,
			// },
			// Company Profile
			{
				path: '/about-us',
				element: <About />,
			},
			{
				path: '/our-business',
				element: <Business />,
			},
			{
				path: '/career-opportunities',
				element: <Career />,
			},
			// {
			// 	path: '/contact-us',
			// 	element: <Contact />,
			// },
			{
				path: '/support-center',
				element: <SupportCenter />,
			},
			{
				path: '/support-center/request-quote',
				element: <Quote />,
			},
			{
				path: '/support-center/feedback',
				element: <Feedback />,
			},
			{
				path: '/news',
				element: <News />,
			},
			{
				path: '/news/:slug',
				element: <NewsDetail />,
			},
			// {
			// 	path: '/knowledge-hub',
			// 	element: <KnowledgeHub />,
			// },
			// {
			// 	path: '/services',
			// 	element: <Service />,
			// },
			{
				path: '/locations',
				element: <Location />,
			},
			{
				path: '/privacy-policy',
				element: <Privacy />,
			},
			{
				path: '/cookie-policy',
				element: <Cookie />,
			},
			// UnFound Page
			{ path: "*", element: <ErrorPage /> },
		]
	}
]);

export default Router;
